var render = function render(){var _vm=this,_c=_vm._self._c;return _c('connection-required-offline-mode-wrapper',[_c('project-video-top-bar-controls',{staticClass:"video__top-controls"}),_c('div',{staticClass:"video__wrapper",style:({
      paddingLeft: _vm.wrapperPaddingLeft,
      transition: _vm.wrapperTransition,
    })},[_c('iframe',{attrs:{"src":`https://player.vimeo.com/video/${_vm.vimeoVideoId}/?${_vm.vimeoSettingsQueryString}`,"frameborder":"0","allow":`autoplay; ${_vm.enableVideoFullscreen ? 'fullscreen' : ''}`,"allowfullscreen":_vm.enableVideoFullscreen}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }